export default "__VITE_ASSET__DBmQJhVt__"